import posthog from "posthog-js";
import { useAuth } from "../contexts/AuthContext";

/**
 * Returns a `track(event, props)` function that captures PostHog events.
 * Silently no-ops for internal @audiohook.com users so only real client
 * activity appears in analytics.
 */
export function useTrack() {
  const { isSupportUser } = useAuth();
  return (event, props) => {
    if (!isSupportUser) posthog.capture(event, props);
  };
}
